import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vuetify from './plugins/vuetify'
import responsive from 'vue-responsive'
import Vuex from 'vuex'
import VueParallaxView from '@/library/vue-parallax-view/src/index'
import '@/library/vue-parallax-view/dist/vue-parallax-view.css'
import 'vue-organization-chart/dist/orgchart.css'
import '@fortawesome/fontawesome-free/css/all.css'
import orgchart from 'orgchart'
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false
Vue.use(responsive)
Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(VueParallaxView)
Vue.use(orgchart)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
